import { useQuery } from '@tanstack/react-query';

import { overrideFormulaFieldsWithMessageContent } from '../../helpers/formulaHelpers';

import { FormulaDetailModel } from '../../models/formula.model';

import API from '../../services/api';

import { queryClient } from '../../AppComposer';
import useGetAndUpdateMessageContent from '../message-content/useMessageContentGetAndUpdate';
import formulaKeys from './_queryKeys';
import { normalizeEmptyDatasetFilters } from './helper';

const getFormula = async (formulaId: number): Promise<FormulaDetailModel> => {
    const { data } = await API.fetchFormula(formulaId);

    // TODO: move this logic to message content after it supports dataset_filters
    const output = {
        ...data,
        dataset_filters: normalizeEmptyDatasetFilters(data?.dataset_filters),
    };

    return output;
};

// since the callbacks have been removed from useQuery hooks, we intentially pass an empty object
// as the options here. If that changes in the future, we can change the type.
export default function useFormulaQuery(formulaId: number, options: {}) {
    const { data: messageContent } = useGetAndUpdateMessageContent(formulaId);
    return useQuery<FormulaDetailModel>({
        queryKey: formulaKeys.formulaById(formulaId),
        queryFn: () => getFormula(formulaId),
        enabled: !!formulaId,
        select: (data) =>
            overrideFormulaFieldsWithMessageContent(data, messageContent),
        ...options,
    });
}

export const getCachedFormula = (formulaId: number) =>
    queryClient.getQueryData(formulaKeys.formulaById(formulaId));
